export const APP_CONFIG = {
  qtdeItensPaginacao: 5,
  keyPassPhrase: "Z1c4rD#Acc3NtiV*", /* 16 Caracteres */
  ivPassPhrase: "Tr4Ck$1nG?saL35!" /* 16 Caracteres */
}
